// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-3011030e] .el-drawer__header {\n  margin-bottom: 0px;\n  padding: 20px;\n}", ""]);
// Exports
module.exports = exports;
